import ApiModel from "../../../../models/ApiModel";

export default class ApiBalanceProducts extends ApiModel {
  pathDef = 'public/products/balance-products';

//   index(params){
//     this.__responseIsArray = false;
//     this.isCheckPagination = false;
//     this.__params = params;
//     //this.__params = this.pasreParamsForGet(params);
//     this.__path = ('index' in this.paths) ? this.paths.index : this.pathDef;
//     this.formatterResponseData = (rdata) =>{
//         return rdata.response.data;
//     }
//   }
}